<template>
  <div id="gift-card-popup-trans" class="pos-fixed" @click.stop.prevent>
    <div class="overlay" @click.stop.prevent="hideGCTrans(model.gift_card)"></div>
    <div class="bg-light card-details gc-trans padding-10 pos-fixed pos-center-hor index-3 radius-3 margin-5" style="margin: auto 5px;">
      <div class="card-name margin-bottom-20 font-bold">{{giftContent.name}}</div>
      <div class="redeemed-details text-semi-small">
        <img class="w30 margin-bottom-5" :src="giftContent.image_url">
        <table class="text-left">
          <tbody>
            <tr>
              <td>Date:</td>
              <td class="font-bold">03 Sep 2020</td>
            </tr>
            <tr>
              <td>Ref Number:</td>
              <td class="font-bold">{{refNum}}</td>
            </tr>
            <tr>
              <td>Name:</td>
              <td class="font-bold">{{receiverName}}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td class="font-bold">{{receiverEmail}}</td>
            </tr>
            <tr>
              <td>Gift Card Value:</td>
              <td class="font-bold">₹{{giftContent.value}}</td>
            </tr>
            <tr>
              <td>Balance Used:</td>
              <td class="align-hor center-ver font-bold">
                <img class="w-15 margin-right-5" :src="userHeaderBalance.icon">
                <div>{{formatReward(giftContent.currency_label, giftContent.currency_req, true)}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  export default {
    mixins: [globals],
    props: {
      model: Object
    },
    data() {
      return {
        receiverName: '',
        receiverEmail: '',
        refNum: ''
      }
    },
    methods: {
      hideGCTrans(gc) {
        gc.show_popup = false
      }
    },
    created() {
      var trans = this.model
      if(!this.isEmpty(trans) && !this.isEmpty(trans.gift_card)) {
        var gc = trans.gift_card
        var tempObj = {}
        tempObj.name = gc.pr_name;
        tempObj.value = gc.amount;
        tempObj.currency_req = trans.value;
        tempObj.currency_label = trans.prize_type;
        tempObj.image_url = gc.pr_image;
        tempObj.show_popup = true;
        this.receiverName = gc.name;
        this.receiverEmail = gc.email;
        this.refNum = gc.ref_num;
        this.$store.state.gift_content = tempObj;
        this.$store.state.giftCardBuy = false;
      }
    }
  }
</script>

<style>
  .card-details.gc-trans {
    transform: translateY(50%);
    margin: 10px;
  }
</style>